import { useCallback } from 'react';
import type { Coordinates } from '../../../types/GlobalTypes';
import { defaultMapCenter } from '../static/mapDefaults';

export function useMapCenter(center?: Coordinates) {
  return useCallback(() => {
    return center ?? defaultMapCenter;
  }, [center]);
}
